export const namespaced = true;

export const state = {
  homeItems: [
    {
      id: 1,
      name: 'corporation',
      imagePath: 'Icon awesome-building.png',
      title: '法人管理',
      forwardPath: 'corporation-detail',
      superiorForwardPath: 'corporation',
    },
    {
      id: 2,
      name: 'brand',
      imagePath: 'Icon material-school.png',
      title: 'ブランド管理',
      forwardPath: 'brand-detail',
      superiorForwardPath: 'brand',
    },
    {
      id: 3,
      name: 'school',
      imagePath: 'Icon awesome-school.png',
      title: '教場管理',
      forwardPath: 'school-detail',
      superiorForwardPath: 'school',
    },
    {
      id: 4,
      name: 'course',
      imagePath: 'Icon awesome-book-reader.png',
      title: 'コース管理',
      forwardPath: 'course',
      superiorForwardPath: 'course',
    },
    {
      id: 5,
      name: 'teacher',
      imagePath: 'Icon awesome-chalkboard-teacher.png',
      title: '先生管理',
      forwardPath: 'teacher',
      superiorForwardPath: 'teacher',
    },
    {
      id: 6,
      name: 'class',
      imagePath: 'Icon awesome-chair.png',
      title: 'クラス管理',
      forwardPath: 'class',
      superiorForwardPath: 'class',
    },
    {
      id: 7,
      name: 'student',
      imagePath: 'Icon awesome-child-big.png',
      title: '生徒管理',
      forwardPath: 'student',
      superiorForwardPath: 'student',
    },
    {
      id: 8,
      name: 'information',
      imagePath: 'Icon material-assignment.png',
      title: 'お知らせ管理',
      forwardPath: 'notification',
      superiorForwardPath: 'notification',
    },
    {
      id: 9,
      name: 'experience',
      imagePath: 'Icon metro-folder-open.png',
      title: '体験ID範囲設定',
      forwardPath: 'trial-course-setting',
      superiorForwardPath: 'trial-course-setting',
    },
    {
      id: 10,
      name: 'material',
      imagePath: 'Icon awesome-book.png',
      title: '教材購入サイト管理',
      forwardPath: 'home',
      superiorForwardPath: 'home',
    },
    {
      id: 11,
      name: 'contact',
      imagePath: 'Icon material-contact-mail.png',
      title: 'おうち用アドレス変更',
      forwardPath: 'home',
      superiorForwardPath: 'home',
    },
    {
      id: 12,
      name: 'frozen',
      imagePath: 'Icon metro-lock.png',
      title: '凍結ID管理',
      forwardPath: 'frozen',
      superiorForwardPath: 'frozen',
    },
  ],
};

export const getters = {
  getHomeItemByName: (state) => (name) => {
    return state.homeItems.find((item) => item.name === name);
  },
};
